// extracted by mini-css-extract-plugin
export default {"container":"AdsSmall_container__ZCwuZ","title":"AdsSmall_title__rKGdn","titleColor":"AdsSmall_titleColor__yXwxQ","readMore":"AdsSmall_readMore__9At4v","r1":"AdsSmall_r1__jhNHG"};